import { useAppDispatch } from '../../../app/hooks';
import { setModalOpen } from '../campaignsSlice';
import { Testata } from '../../../hooks/useTestate';

interface ModalDeleteUrlTestataProps {
  urlId: string;
  testata: Testata;
  onDelete: () => void;
}

const ModalDeleteUrlTestata = ({
  urlId,
  testata,
  onDelete,
}: ModalDeleteUrlTestataProps) => {
  const dispatch = useAppDispatch();

  return (
    <div className="modal-delete-user" style={{ maxWidth: '420px' }}>
      <span className="h2">Sei sicuro di voler eliminare questo indirizzo?</span>

      <div className="user">
        <span className="user__name" style={{ wordBreak: 'break-word' }}>
          {atob(urlId)}
        </span>
      </div>

      <div className="ctas">
        <div className="cta" onClick={() => dispatch(setModalOpen())}>
          <span>Annulla</span>
        </div>
        <div
          className="cta cta__delete"
          onClick={() => {
            onDelete();
            dispatch(setModalOpen());
          }}
        >
          <span>Elimina</span>
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteUrlTestata;
